// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"4566a51599bb697b5684","655":"c4742b8e4950cf8e9850"}[chunkId] + ".js";
};